import React from "react";
import _ from "lodash";
import PageSizeSelector from "./PageSizeSelector";
import { useLanguageContext } from "./../../Context/LanguageContext";
import {
  useCurrentPageActionContext,
  useAMGSelectedContext,
  useCurrentPageContext,
  useMainGridSortContext,
} from "../../Context/GlobalContext";
import { usePageSizeActionContext } from "../../Context/GlobalContext";
import { useItemSelectedFilterContext } from "../../Context/GridEquipListContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import equipmentGroupActions from ".././../Actions/EquipmentGroupActions";
import { _helper } from "../GlobalFunction/dateHelper";
const Paginator = ({
  pageCount,
  activePage,
  // setCurrentPage,
  rowCount,
  pageSize,
  setPageSize,
  firstRowOnPage,
  lastRowOnPage,
  reportCode,
}) => {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const UpdateCurrentPage = useCurrentPageActionContext();
  const UpdatePageSize = usePageSizeActionContext();
  const { localization } = useLanguageContext();
  const PagingOption = [50, 100, 500, 1000];
  const selectedAnlageG = useAMGSelectedContext();
  const sortBy = useMainGridSortContext();
  const itemSelectedFilter = useItemSelectedFilterContext();

  const GoToNext = (e) => {
    e.preventDefault();
    let _nextpage = activePage + 1;
    var _lastSelectedPage = activePage;
    sessionStorage.setItem("lastSelectedPage", _lastSelectedPage);
    handleChanges(_nextpage, false);
    UpdateCurrentPage(_nextpage);
  };

  const handlePrev = (e) => {
    e.preventDefault();
    let _prevpage = activePage - 1;
    var _lastSelectedPage = activePage;
    sessionStorage.setItem("lastSelectedPage", _lastSelectedPage);
    handleChanges(_prevpage, false);
    UpdateCurrentPage(_prevpage);
  };

  //let totalcount = pageCount > 9 ? 9 : pageCount;

  let _disableNext =
    activePage == pageCount
      ? true
      : lastRowOnPage < rowCount && activePage != pageCount
      ? false
      : true;
  // ||  lastRowOnPage<rowCount ? true : false;
  let _bgNext = _disableNext
    ? {
        backgroundColor: "white",
        border: "none",
      }
    : {
        backgroundColor: "white",
        border: "none",
        color: "black",
      };
  // { display: 'none' } : { display: 'block' };

  let _disableprev = activePage == 1 ? true : false;
  let _bgprev = _disableprev
    ? {
        backgroundColor: "white",
        border: "none",
      }
    : {
        backgroundColor: "white",
        border: "none",
        color: "black",
      };
  function handleChanges(_value, isPageChange) {
    setGlobalSpinner(true);
    const FilterList =
      reportCode === "EquipList"
        ? itemSelectedFilter
        : itemSelectedFilter.length === 0
        ? [
            {
              Name: "LastCheckDate",
              Value: _helper.lastCheckDateFromCurrent(30),
              Operator: ">",
            },
          ]
        : itemSelectedFilter;
    equipmentGroupActions.getEquipmentList2(
      reportCode,
      reportCode === "EquipList" ? sortBy.order : "asc",
      selectedAnlageG,
      parseInt(isPageChange ? 1 : _value),
      parseInt(isPageChange ? _value : pageSize),
      reportCode === "EquipList" ? sortBy.key : "pruefdatum",

      null,
      FilterList
    );
  }

  return pageCount > 0 ? (
    <>
      <div className="paginator">
        <div className="paginator-outer-container">
          <div className="paginator-container">
            <div className="paginator-page-size">
              <div className="paginator-page-size-label">
                {" "}
                {localization.dropDown}
              </div>
              <select
                className="form-field paginator-page-size-select"
                value={pageSize}
                onChange={(e) => {
                  sessionStorage.setItem("pageSize", e.target.value);
                  handleChanges(e.target.value, true);
                  UpdateCurrentPage(1);
                  UpdatePageSize(e.target.value);
                }}
                style={{
                  border: "none",
                  borderBottom: "solid rgb(0, 103, 127)",
                }}
              >
                {Object.keys(PagingOption).map((id) => {
                  let option = PagingOption[id];
                  if (option === pageSize) {
                    return (
                      <option key={"page-" + id} defaultValue={option}>
                        {option}
                      </option>
                    ); //selected
                  } else {
                    return (
                      <option key={"page-" + id} value={option}>
                        {option}
                      </option>
                    );
                  }
                })}
              </select>
            </div>
            <div className="paginator-range-actions">
              <div className="paginator-range-label">
                {" "}
                {firstRowOnPage +
                  " - " +
                  lastRowOnPage +
                  "   " +
                  localization.ofLbl +
                  "   " +
                  rowCount}
              </div>
              <button
                type="button"
                aria-label="Previous"
                disabled={_disableprev}
                style={_bgprev}
                onClick={handlePrev}
                // style={_disableprev}
              >
                <span className="glyphicon glyphicon-menu-left"></span>
                <span></span>
              </button>
              <button
                type="button"
                aria-label="Next page"
                disabled={_disableNext}
                style={_bgNext}
                onClick={GoToNext}
              >
                <span className="glyphicon glyphicon-menu-right"></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
};

// const Paginator = (props) => {
//   const { pageCount, activePage, setCurrentPage, rowCount, pageSize } = props;
//   return (
//     <div className="row">
//       <div className="col">{pageCount}</div>
//       <div className="col">{activePage}</div>
//     </div>
//   );
// };
export default Paginator;
